import React from 'react'

import { Span } from './span'

type Props = {
  label: string
  checked: boolean
  innerRef?: React.ForwardedRef<HTMLInputElement>
} & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

export function Checkbox({ label, checked, innerRef, ...rest }: Props) {
  return (
    <>
      <input
        className="form-checkbox h-4 w-4 rounded-[2px] border border-solid border-moss-300 text-cobranding transition-colors invalid:border-error-600 invalid:outline-none focus:outline-none focus:ring-0 focus:ring-white [&:not(:disabled)]:hover:border-electric-650 [&:not(:disabled)]:hover:outline-none [&:not(:disabled)]:focus:border-electric-650 [&:not(:disabled)]:focus:outline-none"
        type="checkbox"
        checked={checked}
        ref={innerRef}
        readOnly
        aria-label={label}
        {...rest}
      />
      <Span className="text-sm">{label}</Span>
    </>
  )
}
